import * as tslib_1 from "tslib";
import selectPopShowOption from '../actions/selectPopShowOption';
import selectPopMessageSettingOption from '../actions/selectPopMessageSettingOption';
import store from '../store/store';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getPopImapConfiguration } from 'owa-popimap-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';
import { isConsumer } from 'owa-session-store';
var styles = require('./PopImapOption.scss');
var ENABLE = 'enable';
var DISABLE = 'disable';
var PopImapFull = /** @class */ (function (_super) {
    tslib_1.__extends(PopImapFull, _super);
    function PopImapFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPopShowChange = function (ev, option) {
            selectPopShowOption(option.key == ENABLE);
        };
        _this.onPopMessageSettingChange = function (ev, option) {
            selectPopMessageSettingOption(option.key == ENABLE);
        };
        return _this;
    }
    PopImapFull.prototype.render = function () {
        var popImapConfiguration = getPopImapConfiguration();
        if (!popImapConfiguration) {
            return React.createElement(Spinner, null);
        }
        var optionStore = this.props.optionStore;
        var popEnabled = getFallbackValueIfNull(optionStore.popEnabled, popImapConfiguration.popEnabled);
        var popMessageDeleteEnabled = getFallbackValueIfNull(optionStore.popMessageDeleteEnabled, popImapConfiguration.popMessageDeleteEnabled);
        var popSettings = popEnabled
            ? getFallbackValueIfNull(optionStore.popSettings, popImapConfiguration.popSettings)
            : strings.options_pop_messagesettingdisabledLabel;
        var imapSettings = getFallbackValueIfNull(optionStore.imapSettings, popImapConfiguration.imapSettings);
        var smtpSettings = getFallbackValueIfNull(optionStore.smtpSettings, popImapConfiguration.smtpSettings);
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.settingContainer },
                React.createElement(Label, { className: styles.settingHeader }, strings.options_pop_headerLabel),
                React.createElement(ChoiceGroup, { className: styles.popChoices, selectedKey: popEnabled ? ENABLE : DISABLE, label: strings.options_pop_toggleLabel, options: [
                        {
                            key: ENABLE,
                            text: strings.options_pop_enabled,
                        },
                        {
                            key: DISABLE,
                            text: strings.options_pop_disabled,
                        },
                    ], onChange: this.onPopShowChange, disabled: !isConsumer() }),
                popEnabled && isConsumer() ? (React.createElement(ChoiceGroup, { className: styles.popChoices, selectedKey: popMessageDeleteEnabled ? ENABLE : DISABLE, label: strings.options_pop_messagesettingLabel, options: [
                        {
                            key: DISABLE,
                            text: strings.options_pop_dontallow,
                        },
                        {
                            key: ENABLE,
                            text: strings.options_pop_allow,
                        },
                    ], onChange: this.onPopMessageSettingChange })) : null),
            React.createElement("div", { className: styles.settingContainer },
                React.createElement(Label, { className: styles.settingHeader }, strings.options_pop_messagesettingheaderLabel),
                React.createElement("textarea", { className: styles.settingValue, value: popSettings })),
            React.createElement("div", { className: styles.settingContainer },
                React.createElement(Label, { className: styles.settingHeader }, strings.options_imap_settingLabel),
                React.createElement("textarea", { className: styles.settingValue, value: imapSettings })),
            React.createElement("div", { className: styles.settingContainer },
                React.createElement(Label, { className: styles.settingHeader }, strings.options_smtp_settingLabel),
                React.createElement("textarea", { className: styles.settingValue, value: smtpSettings }))));
    };
    PopImapFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
        })
    ], PopImapFull);
    return PopImapFull;
}(React.Component));
export default PopImapFull;
//# sourceMappingURL=PopImapFull.js.map